module.exports = __webpack_public_path__ + "static/S-Factor_Newsletter_Feb2020-02b78bb55fd60a029e9a846858be000a.pdf";